import React from 'react';

export const PHASE_STATUS_COLORS = {
  'Not Started': 'bg-white/10 text-white/60',
  'In Progress': 'bg-amber-400/15 text-amber-300 border border-amber-300/30',
  Blocked: 'bg-rose-500/15 text-rose-300 border border-rose-400/30',
  Done: 'bg-emerald-500/15 text-emerald-300 border border-emerald-400/30',
};

export const PROJECT_STATUS_COLORS = {
  Draft: 'bg-white/10 text-white/60',
  'In Progress': 'bg-amber-400/15 text-amber-300',
  'Under Review': 'bg-sky-400/15 text-sky-300',
  Completed: 'bg-emerald-500/15 text-emerald-300',
  Archived: 'bg-white/5 text-white/40',
};

export const RAG_COLORS = { Green: 'bg-emerald-400', Amber: 'bg-amber-400', Red: 'bg-rose-500' };

export const StatusBadge = ({ status, map = PROJECT_STATUS_COLORS, testid }) => (
  <span data-testid={testid} className={`inline-flex px-2.5 py-0.5 rounded-full text-[10.5px] font-bold ${map[status] || 'bg-white/10 text-white/60'}`}>
    {status}
  </span>
);

export const RagDot = ({ rag }) => rag ? (
  <span className="inline-flex items-center gap-1.5 text-[10.5px] font-semibold text-white/60">
    <span className={`w-2 h-2 rounded-full ${RAG_COLORS[rag] || 'bg-white/30'}`} />
    Mentor: {rag}
  </span>
) : null;

export const ProgressRing = ({ pct = 0, size = 56, stroke = 5, className = '' }) => {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  return (
    <svg width={size} height={size} className={className} data-testid="cap-progress-ring">
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth={stroke} />
      <circle
        cx={size / 2} cy={size / 2} r={r} fill="none"
        stroke={pct >= 100 ? '#34d399' : '#fbbf24'} strokeWidth={stroke} strokeLinecap="round"
        strokeDasharray={c} strokeDashoffset={c * (1 - pct / 100)}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ transition: 'stroke-dashoffset 0.6s ease' }}
      />
      <text x="50%" y="52%" dominantBaseline="middle" textAnchor="middle" fill="white" fontSize={size / 4.2} fontWeight="700">
        {pct}%
      </text>
    </svg>
  );
};

export const fmtDate = (d) => {
  if (!d) return '—';
  try { return new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }); }
  catch { return d; }
};

export const Field = ({ label, children, hint }) => (
  <label className="block">
    <div className="text-[10px] tracking-[0.2em] font-bold uppercase text-white/50 mb-1.5">{label}</div>
    {children}
    {hint && <div className="text-[10.5px] text-white/35 mt-1 italic">{hint}</div>}
  </label>
);

export const inputCls = 'w-full bg-white/[0.04] border border-white/12 rounded-lg px-3 py-2 text-sm text-white placeholder:text-white/25 focus:outline-none focus:border-amber-300/60 transition-colors';
export const btnAmber = 'inline-flex items-center gap-2 px-4 py-2 rounded-md bg-amber-300 hover:bg-amber-200 text-slate-900 text-sm font-semibold transition-colors disabled:opacity-40 disabled:cursor-not-allowed';
export const btnGhost = 'inline-flex items-center gap-2 px-3.5 py-2 rounded-md border border-white/15 hover:border-white/35 text-sm text-white/75 hover:text-white transition-colors disabled:opacity-40';
